// extracted by mini-css-extract-plugin
export default {"heading":"UsertypesSect_heading__pkTiz","checkmarkBoxContainer":"UsertypesSect_checkmarkBoxContainer__+jJr6"};